import React, { ReactNode } from 'react';

import { Box, Stack } from '@mui/system';

import { cn } from '../lib/utils';

const AcViewWrapper = ({
  className,
  children,
  header,
  isDisabled = false,
  scrollBodyFillsSpace = false
}: {
  className?: string;
  children: ReactNode;
  header?: ReactNode;
  isDisabled?: boolean;
  scrollBodyFillsSpace?: boolean;
}) => {
  return (
    <Stack
      direction="column"
      height="100%"
      className={cn(
        scrollBodyFillsSpace && 'min-h-0',
        isDisabled &&
          "relative after:content-[''] after:absolute after:bg-white after:top-[40px] after:left-0 after:w-full after:h-full after:z-8 after:opacity-70",
        className
      )}
    >
      {header}
      <Box
        className={cn(
          scrollBodyFillsSpace
            ? 'min-h-0 flex-1 overflow-auto'
            : 'overflow-auto'
        )}
      >
        {children}
      </Box>
    </Stack>
  );
};

export default AcViewWrapper;
